import { NgModule } from '@angular/core';
import { CmsConfig, I18nConfig, provideConfig } from "@spartacus/core";
import { userAccountTranslationChunksConfig, userAccountTranslationsDe, userAccountTranslationsEn } from "@spartacus/user/account/assets";
import { UserAccountRootModule } from "@spartacus/user/account/root";
import { userProfileTranslationChunksConfig, userProfileTranslationsDe, userProfileTranslationsEn } from "@spartacus/user/profile/assets";
import { UserProfileRootModule } from "@spartacus/user/profile/root";
import { nl as translationsNl } from '../../../../assets/i18n-assets/nl';

@NgModule({
  declarations: [],
  imports: [UserAccountRootModule, UserProfileRootModule],
  providers: [
    provideConfig(<CmsConfig>{
      featureModules: {
        userAccount: {
          module: () =>
            import('@spartacus/user/account').then((m) => m.UserAccountModule),
        },
      },
    }),
    provideConfig(<I18nConfig>{
      i18n: {
        resources: {
          en: userAccountTranslationsEn,
          de: userAccountTranslationsDe,
          nl: translationsNl,
        },
        chunks: userAccountTranslationChunksConfig,
      },
    }),
    provideConfig(<CmsConfig>{
      featureModules: {
        userProfile: {
          module: () =>
            import('@spartacus/user/profile').then((m) => m.UserProfileModule),
        },
      },
    }),
    provideConfig(<I18nConfig>{
      i18n: {
        resources: {
          en: userProfileTranslationsEn,
          de: userProfileTranslationsDe,
          nl: translationsNl,
        },
        chunks: userProfileTranslationChunksConfig,
      },
    }),
  ],
})
export class UserFeatureModule {}
